import React from "react";
import { ProductFormValues } from "../../components/ProductForm/types";

export const ScreenContext = React.createContext<{
  onSubmit: ({ name }: { name: string }) => void;
  originalFormValues: ProductFormValues;
}>({
  onSubmit: () => {},
  originalFormValues: {} as ProductFormValues,
});

export type NameSuggestion = {
  name: string;
  reasoning: string;
};
